export default {
	get: key => {
		const cookie = {};
		document.cookie.split(";").forEach(item => {
			const parts = item.split("=", 2);
			cookie[decodeURIComponent(parts[0].trim())] = decodeURIComponent((parts[1] || "").trim());
		});
		if (!key) {
			return cookie;
		}
		if (cookie[key]) {
			return cookie[key];
		}
		return null;
	},
	set: (key, value, age, path) => {
		let cookie = encodeURIComponent(key) + "=" + encodeURIComponent(value) + "; samesite=lax; path=" + (path ? encodeURIComponent(path) : "/");
		if (age) {
			cookie += "; max-age=" + age;
		}
		if (location.protocol === "https:") {
			cookie += "; secure";
		}
		document.cookie = cookie;
	}
};